import Lenis from "lenis";

let lenisInstance = null;

export function initLenis() {
  if (lenisInstance) return lenisInstance;
  lenisInstance = new Lenis({ duration: 1.0, smoothWheel: true, touchMultiplier: 1.4 });
  function raf(time) {
    lenisInstance.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  if (typeof window !== "undefined") window.__lenis = lenisInstance;
  return lenisInstance;
}

export function scrollToSection(selector) {
  const el = document.querySelector(selector);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -70, duration: 1.1 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export function scrollToTop() {
  if (lenisInstance) {
    lenisInstance.scrollTo(0, { duration: 1.1 });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
